import React, { useState } from 'react';
import { useEffect } from 'react';
import '../../css/accordion.css';
import { accordianexpand } from '../../paths/defaultImage';
import LazyImage from './lazyLoad';
const Accordion = ({
  Title,
  body,
  Dots,
  card,
  toggle,
  isLastElement,
  isIconPresent,
  menuCard,
  noDottedLine,
  customTitleStyle,
  subHeader,
  isAccordionCollapsed,
  setIsAccordionCollapsed,
}) => {
  const [toggleTitle, setToggleTitle] = useState(true);
  useEffect(() => {
    setToggleTitle(!isAccordionCollapsed);
  }, [isAccordionCollapsed]);
  return (
    <>
      <div className={`accordian ${card ? 'box-shadow-card' : ''}`}>
        <div
          className={` d-flex justify-content-between fs-18 ${customTitleStyle || 'px-20'} ${
            menuCard ? 'menu-card-header' : ''
          } ${!toggleTitle ? 'py-2' : 'pt-2'} `}
          onClick={() => {
            setToggleTitle((prev) => !prev);
            setIsAccordionCollapsed && setIsAccordionCollapsed((prev) => !prev);
          }}>
          <div className='title d-flex flex-column'>
            <Title toggleTitle={toggleTitle} />
            {subHeader && !isAccordionCollapsed && (
              <div className='text-muted fs-12 fw-500'>{subHeader}</div>
            )}
          </div>
          <div className='d-flex align-items-center py-2 pointer'>
            <LazyImage
              src={accordianexpand}
              alt='collapse-expand'
              className={`udarrow ${
                !toggleTitle ? 'rotate-collapse-icon' : 'rotate-collapse-icon-default'
              }`}
            />
          </div>
        </div>

        <div style={{ display: toggleTitle ? 'block' : 'none' }} className='content '>
          {body}
        </div>
        {!toggleTitle && !isLastElement && !noDottedLine && (
          <hr className='dotted-line mb-0 w-100' />
        )}
      </div>
    </>
  );
};

export default Accordion;
